import React from "react";
import { DjDevice } from "./types";

// "Devices" row on the talent card: which app / website this talent uses,
// the app version, and when each was last seen (server lib/admin/djDevices.js).
const LABEL: Record<DjDevice["platform"], string> = {
  ios: "iPhone app",
  android: "Android app",
  web: "Website",
  desktop: "Desktop app",
};

export function lastSeenText(at: string | null, now = new Date()): string {
  if (!at) return "last seen unknown";
  const then = new Date(at);
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(now) - startOfDay(then)) / 86400000);
  if (days <= 0) return "last seen today";
  if (days === 1) return "last seen yesterday";
  if (days < 30) return `last seen ${days} days ago`;
  return `last seen ${then.toLocaleDateString()}`;
}

// The value of the Devices row on the talent card: one line per platform, the
// last-seen time under it.
export function DjDevices({ devices }: { devices: DjDevice[] }) {
  if (devices.length === 0) return <span className="ac-muted">No device data yet</span>;
  return (
    <>
      {devices.map((d) => (
        <span key={d.platform} className="ac-device" title={d.lastSeenAt ? new Date(d.lastSeenAt).toLocaleString() : undefined}>
          {LABEL[d.platform] || d.platform}
          {d.appVersion && d.platform !== "web" ? ` ${d.appVersion}` : ""}
          <span className="ac-sub">{lastSeenText(d.lastSeenAt)}</span>
        </span>
      ))}
    </>
  );
}
